import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavTabs, NavTab } from '4all-ui/components/NavTabs';
import * as styles from './style';
import { PATHS } from '../../helpers/constants';
import { HEADER_TITLE_HEIGHT } from '../../styles/variables';

const customNavTabStyle = {
  padding: '5px 10px',
};

class Navbar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hideHeaderTitle: false,
      changeHeight: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onWindowScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.changeHeight && !this.state.hideHeaderTitle) {
      this.setState({ hideHeaderTitle: true });
    }
    if (!nextState.changeHeight && this.state.hideHeaderTitle) {
      this.setState({ hideHeaderTitle: false });
    }
  }

  onWindowScroll = () => {
    const d = document.documentElement;
    if (!this.state.changeHeight && d.scrollTop > HEADER_TITLE_HEIGHT) {
      this.setState({ changeHeight: true });
    }
    if (this.state.changeHeight && d.scrollTop <= HEADER_TITLE_HEIGHT) {
      this.setState({ changeHeight: false });
    }
  };

  render() {
    return (
      <Fragment>
        <styles.NavbarOuter>
          <styles.NavbarContainer boxShadow noMargin>
            <styles.HeaderTitle /* hideHeaderTitle={this.state.hideHeaderTitle} */>
              <styles.Content>
                <styles.Title>Produtos</styles.Title>
              </styles.Content>
            </styles.HeaderTitle>
            <styles.Content>
              <NavTabs>
                <NavTab
                  id="nav-link-products"
                  path={PATHS.products}
                  activeClassName="active"
                  customStyles={customNavTabStyle}
                  width="200px"
                >
                  Meus Produtos
                </NavTab>
                <NavTab
                  id="nav-link-menu"
                  path={PATHS.menu}
                  activeClassName="active"
                  customStyles={customNavTabStyle}
                  width="200px"
                >
                  Cardápios
                </NavTab>
                <NavTab
                  id="nav-link-variations"
                  path={PATHS.globalVariations}
                  activeClassName="active"
                  customStyles={customNavTabStyle}
                  width="200px"
                >
                  Variações Globais
                </NavTab>
              </NavTabs>
              {this.props.button}
            </styles.Content>
          </styles.NavbarContainer>
        </styles.NavbarOuter>
        <styles.NavbarOuter /* changeHeight={this.state.changeHeight} */>
          <styles.NavbarContainer hideHeaderTitle={this.state.hideHeaderTitle}>
            {this.props.children}
          </styles.NavbarContainer>
        </styles.NavbarOuter>
      </Fragment>
    );
  }
}

Navbar.propTypes = {
  button: PropTypes.any,
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js